import { useCatalogContext } from '../contexts/CatalogContext';

// Este hook agora é apenas um wrapper leve.
// Ele NÃO guarda estado, NÃO faz fetch, NÃO ocupa memória.
export function useCatalog() {
  const context = useCatalogContext();
  
  if (!context) {
    // Fallback de segurança caso esqueça o Provider
    return { 
      catalog: {}, 
      loading: true, 
      findItem: () => null,
      findCatalogItem: () => null,
      refreshCatalog: () => {}
    };
  }

  return {
    catalog: context.catalog,
    moldeSkuMap: context.moldeSkuMap || {},
    subestoqueCeraMap: context.subestoqueCeraMap || {},
    isMoldeSku: context.isMoldeSku || (() => false),
    getSubestoqueCera: context.getSubestoqueCera || (() => ({ cera_bruta: 0, cera_precravada: 0, localizacao_gaveta: "", historico: [] })),
    loading: context.loading,
    findItem: context.findItem,
    findCatalogItem: context.findItem, // Alias para compatibilidade
    refreshCatalog: context.refreshCatalog
  };
}